import createGUID from 'utility/helper-functions/createGUID';

class McqAnswer {
    guidRef: string = createGUID(8);
    answerText: string = "";
    isCorrect: boolean = false;
}

export { McqAnswer};